"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { trendClass } from "./BoltTrendUtils";

export default function BoltCorrectScoresSection({ title, correctScoresFull }) {
  const { home = [], draw = [], away = [] } = correctScoresFull || {};
  const allScores = [...home, ...draw, ...away];

  if (allScores.length === 0) return null;

  return (
    <div className="kbv-v26-odt-item ods-100">
      <div className="kbv-v26-odt-title">
        <span>{title}</span>
        <span></span>
      </div>
      <div className="kbv-v26-odt-odds-list scores-grid">
        {home.map((item, i) => (
          <div key={`h${i}`}>
            <div className="kbv-v26-odt-label">{item.label}</div>
            <div className="score-values">
              <div className={`kbv-v26-odt-odds ${trendClass(item.trend)}`}>
                {displayValue(item.value)}
              </div>
              {item.value2 !== undefined && (
                <div className={`kbv-v26-odt-odds ${trendClass(item.trend2)}`}>
                  {displayValue(item.value2)}
                </div>
              )}
            </div>
          </div>
        ))}
        {draw.map((item, i) => (
          <div key={`d${i}`}>
            <div className="kbv-v26-odt-label">{item.label}</div>
            <div className="score-values">
              <div className={`kbv-v26-odt-odds ${trendClass(item.trend)}`}>
                {displayValue(item.value)}
              </div>
            </div>
          </div>
        ))}
        {away.map((item, i) => (
          <div key={`a${i}`}>
            <div className="kbv-v26-odt-label">{item.label}</div>
            <div className="score-values">
              <div className={`kbv-v26-odt-odds ${trendClass(item.trend)}`}>
                {displayValue(item.value)}
              </div>
              {item.value2 !== undefined && (
                <div className={`kbv-v26-odt-odds ${trendClass(item.trend2)}`}>
                  {displayValue(item.value2)}
                </div>
              )}
            </div>
          </div>
        ))}
        <div>
          <div className="kbv-v26-odt-label">AOS</div>
          <div className="score-values">
            <div className="kbv-v26-odt-odds">-</div>
          </div>
        </div>
      </div>
    </div>
  );
}
